import { useEffect, useState } from "react";
import { Timer } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");

export const SaleCountdown = ({ endsAt }) => {
  const [left, setLeft] = useState(() => new Date(endsAt) - Date.now());

  useEffect(() => {
    const t = setInterval(() => setLeft(new Date(endsAt) - Date.now()), 1000);
    return () => clearInterval(t);
  }, [endsAt]);

  if (!endsAt || left <= 0) return null;

  const days = Math.floor(left / 86400000);
  const hrs = Math.floor((left % 86400000) / 3600000);
  const mins = Math.floor((left % 3600000) / 60000);
  const secs = Math.floor((left % 60000) / 1000);
  const units = [
    ...(days > 0 ? [{ v: days, l: "days" }] : []),
    { v: hrs, l: "hrs" },
    { v: mins, l: "min" },
    { v: secs, l: "sec" },
  ];

  return (
    <div className="mt-6 inline-flex items-center gap-3 border border-red-200 bg-red-50/60 px-5 py-3" data-testid="sale-countdown">
      <Timer size={14} className="text-red-500 shrink-0" />
      <span className="text-[10px] uppercase tracking-[0.25em] text-red-500">Sale ends in</span>
      <div className="flex items-baseline gap-2">
        {units.map((u) => (
          <span key={u.l} className="text-zinc-900">
            <span className="font-medium text-lg tabular-nums" data-testid={`countdown-${u.l}`}>{pad(u.v)}</span>
            <span className="text-[9px] uppercase tracking-[0.2em] text-zinc-400 ml-1">{u.l}</span>
          </span>
        ))}
      </div>
    </div>
  );
};
